import swal from 'sweetalert';
import jQuery from 'jquery';
const $ = jQuery;

document.addEventListener('DOMContentLoaded', () => {
    if (document.querySelector('.individual-results')) {
        const reportPrice = document.querySelector('.individual-results').dataset.reportPrice;
        const reportFee = document.querySelector('.individual-results').dataset.reportFee;
        const checkedElement = document.querySelector('.individual-results__checked');
        const subTotalElement = document.querySelector('.individual-results__subtotal__amount');
        const totalFeeElement = document.querySelector('.individual-results__totalFee__amount');
        const totalElement = document.querySelector('.individual-results__total__amount');
        const subTotalInput = document.querySelector('#individual-results__subtotal__input');
        const checkoutButton = document.querySelector('#individual-results__checkout');
        const selectAllButton = document.querySelector('#individual-results__select-all');

        const checkBoxElements = Array.from(
            document.querySelectorAll('input[name="reports[]"]')
        );

        const sumCheckedBoxes = checkBoxes => {
            return checkBoxes.map(checkbox => checkbox.checked)
                .filter(x => x).length;
        };

        const calculatePrice = checkedBoxes => {
            return (reportPrice * checkedBoxes);
        };

        const calculateFee = checkedBoxes => {
            return (reportFee * checkedBoxes);
        };

        const calculateAmounts = () => {
            const totalChecked = sumCheckedBoxes(checkBoxElements);
            if (totalChecked === 0) {
                checkoutButton.disabled = true;
            } else {
                checkoutButton.disabled = false;
            }
            checkedElement.innerHTML = totalChecked;
            const price = calculatePrice(
                sumCheckedBoxes(
                    checkBoxElements
                )
            );
            const totalFee = calculateFee(
                sumCheckedBoxes(
                    checkBoxElements
                )
            );
            const total = price + totalFee;
            subTotalElement.innerHTML = `$${price.toFixed(2)}`;
            totalFeeElement.innerHTML = `$${totalFee.toFixed(2)}`;
            totalElement.innerHTML = `$${total.toFixed(2)}`;
            subTotalInput.value = price;
        };

        selectAllButton.addEventListener('click', () => {
            checkBoxElements.forEach((checkbox) => {
                checkbox.click();
            });
        });

        checkBoxElements.forEach(element => {
            element.addEventListener('click', () => {
                calculateAmounts();
            });
        });

        checkBoxElements.forEach(element => {
            element.disabled = false;
        });

        selectAllButton.disabled = false;

        calculateAmounts();

    }
});

